import React, {Fragment} from 'react';

function PreloadedSection() {
    return (
        <Fragment>
            <section id="contact-details" data-at-id="contact-details" />
            <section id="rules-and-policies" data-at-id="rules-and-policies" />
        </Fragment>
    );
}

export default PreloadedSection;
